import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { ModalDesktop } from '@alfalab/core-components-modal/desktop';

import type { TWrapperDesktopProps } from '../../models';

export const DesktopWrapper: FC<TWrapperDesktopProps> = ({
    children,
    isOpened,
    noContentPaddings,
    onClose,
    size,
    styles,
    title,
}) => (
    <ModalDesktop onClose={onClose} open={isOpened} size={size}>
        <ModalDesktop.Header hasCloser title={title} />
        <ModalDesktop.Content
            className={cn(styles.external, { [styles.noContentPaddings]: noContentPaddings })}
        >
            {children}
        </ModalDesktop.Content>
    </ModalDesktop>
);
